"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addPaddingToImage = void 0;
function addPaddingToImage(image, paddedCrop) {
    var canvas = document.createElement('canvas');
    if (image) {
        canvas.width = paddedCrop.width;
        canvas.height = paddedCrop.height;
        var ctx = canvas.getContext('2d');
        if (ctx) {
            ctx.fillStyle = 'white';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(image, Math.abs(paddedCrop.x), Math.abs(paddedCrop.y));
        }
    }
    return canvas.toDataURL();
}
exports.addPaddingToImage = addPaddingToImage;
